<template>
<div class="chapter">
<div class="inner_page">
<p class="p8">Dedicado a las madres y a sus hijos.</p>
<p class="p1">Trystan, Kewyin, sois mis chicos</p>
<p class="p1">y yo vuestra madre, y</p>
<p class="p1">eso nunca, jamás cambiará.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?a8585f14